import { useRef, useState, useEffect, useContext } from 'react';
import { AppContext } from "./Context";
import './App.css';
import FabricView from './components/FabricView.js';
import Menu from './components/Menu.js';
import SubMenu from './components/SubMenu.js';
import View3D from './components/View3D.js';
import Footer from './components/Footer.js';
import Preloader from './components/Preloader.js';
import ExtraPrice from './components/ExtraPrice.js';

function App() {
  const { state } = useContext(AppContext);
  const { dispatch } = useContext(AppContext);
  const [allLoaded, setAllLoaded] = useState(false);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/userData.json")
      .then((res) => res.json())
      .then((userData) => {
        dispatch({ type: "SET_USER_DATA", payload: userData });
        dispatch({ type: "SET_FAVOURITE", payload: userData.favourite.favourite });
        dispatch({ type: "SET_FABRIC_PRICE", payload: userData.fabric.price });
        dispatch({ type: "SET_FABRIC_CATEGORY", payload: userData.fabric.category });
        dispatch({ type: "SET_FABRIC_CATEGORY_TITLE", payload: userData.fabric.categoryTitle });
        dispatch({ type: "SET_FABRIC_PATTERN", payload: userData.fabric.pattern });
        dispatch({ type: "SET_FABRIC_SHIRT", payload: userData.fabric.shirt });
        dispatch({ type: "SET_FABRIC_TEXTURE", payload: userData.fabric.texture });
        dispatch({ type: "SET_FABRIC_TILE", payload: userData.fabric.tile });
        dispatch({ type: "SET_COLLAR", payload: userData.collar.collar });
        dispatch({ type: "SET_CUFF_CATEGORY", payload: userData.cuff.category });
        dispatch({ type: "SET_CUFF", payload: userData.cuff.cuff });
        dispatch({ type: "SET_CUFF_MESH", payload: userData.cuff.mesh });
        dispatch({ type: "SET_CUFF_PRICE", payload: userData.cuff.price });
        dispatch({ type: "SET_CUFF_BUTTON", payload: userData.cuff.buttons });
        dispatch({ type: "SET_MONOGRAM", payload: userData.monogram.hasMonogram });
        dispatch({ type: "SET_MONOGRAM_PRICE", payload: userData.monogram.price });
        dispatch({ type: "SET_MONOGRAM_TEXT", payload: userData.monogram.text });
        dispatch({ type: "SET_MONOGRAM_LOCATION", payload: userData.monogram.location });
        dispatch({ type: "SET_MONOGRAM_FONT_STYLE", payload: userData.monogram.fontStyle });
        dispatch({ type: "SET_MONOGRAM_COLOR", payload: userData.monogram.color });
        dispatch({ type: "SET_POCKET", payload: userData.pocket.pocket });
        dispatch({ type: "SET_POCKET_PRICE", payload: userData.pocket.price });
        dispatch({ type: "SET_CONTRAST", payload: userData.contrast.contrast });
        dispatch({ type: "SET_CONTRAST_PRICE", payload: userData.contrast.price });
        dispatch({ type: "SET_STITCH", payload: userData.stitch.stitch });
        dispatch({ type: "SET_STITCH_PRICE", payload: userData.stitch.price });
        dispatch({ type: "SET_STITCH_COLOR", payload: userData.stitch.color });
        dispatch({ type: "SET_TUXEDO", payload: userData.tuxedo.tuxedo });
        dispatch({ type: "SET_TUXEDO_PRICE", payload: userData.tuxedo.price });
        dispatch({ type: "SET_PLACKET", payload: userData.placket.placket });
        dispatch({ type: "SET_PLACKET_PRICE", payload: userData.placket.price });

        let meshes = state.visibleMesh;
        meshes.push(userData.collar.collar);
        if (userData.collar.collar == "CollarMandarian") {
          meshes = meshes.filter(item => item !== "Neck");
        } else if (userData.collar.collar == "CollarButtonDown") {
          meshes.push("CollarButton");
          meshes.push("CollarHole");
        } else {
          meshes = meshes.filter(item => item !== "CollarButton");
          meshes = meshes.filter(item => item !== "CollarHole");
        }
        meshes.push(userData.cuff.mesh);
        if (userData.cuff.buttons == 1 && userData.cuff.category == "standard") {
          meshes.push("CuffButton1");
          meshes.push("CuffHole1");
        } else if (userData.cuff.buttons == 2 && userData.cuff.category == "standard") {
          meshes.push("CuffButton2");
          meshes.push("CuffHole2");
        } else if (userData.cuff.category == "french") {
          meshes.push("ButtonRound");
        }
        dispatch({ type: "SET_VISIBLE_MESH", payload: meshes });
        dispatch({ type: "SET_USER_LOADED", payload: true });
      })
      .catch((err) => console.error(err));

    fetch(process.env.PUBLIC_URL + "/fabricData.json")
      .then((res) => res.json())
      .then((json) => {
        dispatch({ type: "SET_FABRIC_DATA", payload: json });
        dispatch({ type: "SET_FABRIC_LOADED", payload: true });
      })
      .catch((err) => console.error(err));

    const updateOrientation = () => {
      if (window.innerHeight > window.innerWidth) {
        dispatch({ type: "SET_ORIENTATION", payload: "portrait" });
      } else {
        dispatch({ type: "SET_ORIENTATION", payload: "landscape" });
      }
    };

    updateOrientation();
    const disableRightClick = (e) => e.preventDefault();
  }, []);

  useEffect(() => {
    if (state.modelLoaded && state.userLoaded && state.fabricLoaded) {
      dispatch({ type: "SET_READY", payload: true });
      setAllLoaded(true);
    }
  }, [state.modelLoaded, state.userLoaded, state.fabricLoaded])

  return (
    < div className="app" >
      {allLoaded && (
        <div className="appUI">
          <Menu />
          <SubMenu />
          <div className='view'>
            <View3D />
          </div>
          <Footer />
          <FabricView />
          <ExtraPrice />
        </div>
      )}
      <Preloader fadeOut={allLoaded} />
    </div >
  )
}
export default App;
